// Default keys
export const ID = 'id';
export const TYPE = 'type';
export const CLIENT_TYPE = 'client-type';
export const CLIENT_ID = 'client-id';

//API identifiers
export const SYSTEM_API = 'atom-admin/v1';
export const ADMIN_API = 'atom-manager/v1';
export const CLIENT_API = 'atom-client/v1';
export const REPORT_API = 'pacesetter-report/v1';

// Invoice
export const RESEND_NOTIFICATION_URL = `${ADMIN_API}/clients/invoice/resend-notification/${TYPE}/${ID}`;

//Note
export const ADD_NOTE_BY_REFERENCE_ID_URL = `${ADMIN_API}/notes`;
export const ADD_NOTE_BY_REFERENCE_ID_BULK_URL = `${ADMIN_API}/notes/bulk`;
export const FETCH_ALL_NOTES_BY_URL = `${ADMIN_API}/notes/search/all`;
export const FETCH_NOTES_BY_PAGINATION_URL = `${ADMIN_API}/notes/search`;
export const GET_ALL_REFERENCE_ID_OF_DOCUMENTS_BY_CLIENT_ID_URL = `${ADMIN_API}/clients/${CLIENT_TYPE}/documents/${CLIENT_ID}/ids`;
export const FETCH_CLIENT_APP_NOTES_BY_PAGINATION_URL = `${CLIENT_API}/notes/search`;

//Documents
export const DOCUMENT_DOWNLOAD_BULK_URL = `${ADMIN_API}/clients/bulk/document/download`;

//Messages
export const MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_URL = `${ADMIN_API}/messages/download/bulk/attachment`;

//Failed Transaction Reports
export const REPORT_ID = 'reportId';
export const ACCESS_CODE = 'accessCode';
export const ACCOUNTING_TRANSACTIONS = `${ADMIN_API}/accounting/transactions`;
export const FETCH_ACCOUNTING_REPORTS_URL = `${ACCOUNTING_TRANSACTIONS}/search`;
export const DOWNLOAD_ACCOUNTING_REPORTS_URL = `${ACCOUNTING_TRANSACTIONS}/export-csv`;
export const MANUAL_TRIGGER_ACCOUNTING_URL = `${ACCOUNTING_TRANSACTIONS}/trigger-sync`;

export const FETCH_FAIL_REPORT_SENT_CONFIGURATION_URL = `${SYSTEM_API}/company/feature-flags/${ACCESS_CODE}`;
export const FETCH_FAIL_REPORT_SENT_CONFIGURATION_FOR_ADMIN_URL = `${ADMIN_API}/company/feature-flags/${ACCESS_CODE}`;
export const UPDATE_FAIL_REPORT_SENT_CONFIGURATION_URL = `${SYSTEM_API}/company/feature-flags`;
